<template>
  <div class="sidebar-menu">
    <!-- Menu -->
    <nav class="list-group list-group-flush menu card shadow-sm">
      <button
        v-for="item in menuItems"
        :key="item.key"
        type="button"
        class="list-group-item list-group-item-action d-flex align-items-center justify-content-between"
        :class="{ active: item.key === activeKey }"
        :aria-current="item.key === activeKey ? 'page' : null"
        @click="$emit('select', item.key)"
      >
        <!-- Ícone + label -->
        <div class="d-flex align-items-center">
          <!-- Ícone à esquerda -->
          <i
            v-if="item.leftIcon || leftIcon"
            :class="['left-icon', 'icofont', item.leftIcon || leftIcon]"
            :style="{ color: item.leftIconColor || leftIconColor }"
            aria-hidden="true"
          ></i>

          <span class="flex-grow-1 ml-2">{{ item.label }}</span>
        </div>

        <div class="d-flex align-items-center">
          <!-- Ícone à direita -->
          <i
            v-if="item.rightIcon || rightIcon"
            :class="['right-icon', 'icofont', item.rightIcon || rightIcon]"
            :style="{ color: item.rightIconColor || rightIconColor }"
            aria-hidden="true"
          ></i>

          <!-- Badge -->
          <span
            v-if="item.badge || badge"
            class="badge ml-2"
            :style="{
              backgroundColor: item.badgeColor || badgeColor,
              color: badgeTextColor,
            }"
          >
            {{ item.badge || badge }}
          </span>
        </div>
      </button>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'SidebarMenu',
  props: {
    menu: { type: Array, required: true },
    activeKey: { type: String, required: true },
    showClose: { type: Boolean, default: false },
    leftIcon: { type: String, default: null },
    leftIconColor: { type: String, default: '#2b2f36' },
    rightIcon: { type: String, default: null },
    rightIconColor: { type: String, default: '#999' },
    badge: { type: [String, Number], default: null },
    badgeColor: { type: String, default: '#5d87ff' },
    badgeTextColor: { type: String, default: '#fff' },
    cidadao: {
      type: Object,
      default: null,
    },
  },
  computed: {
    municipio() {
      return this.$store.state.cidade
    },
    menuItems() {
      const filtrados = this.menu.filter((el) => {
        // se não tiver cidadao, não filtra nada por obito
        if (!this.cidadao) return true

        // se for o item 'pendencias' e tiver dt_obito, remove
        if (el.key === 'pendencias' && this.cidadao.dt_obito != null) {
          return false
        }

        return true
      })

      return filtrados.map((el, index) => {
        return {
          index,
          ...el,
        }
      })
    },
  },
}
</script>

<style scoped lang="scss">
.logo-area {
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 20px;
  padding: 15px;
  border-bottom: 1px solid #f2f2f2;
  .logo {
    max-width: 100px;
  }
  .municipio {
    font-size: 16px;
    font-weight: 700;
    text-align: center;
  }
}

.menu {
  .list-group-item {
    font-size: 0.95rem;
    padding: 0.65rem 0.75rem;
    border: 0;
    border-left: 3px solid transparent;

    & + .list-group-item {
      border-top: 1px solid #f1f3f5;
    }

    &.active {
      background: #f5f7fb;
      color: #2b2f36;
      border-left-color: #5d87ff;
      font-weight: 600;
    }
  }
}

.left-icon,
.right-icon {
  font-size: 1.1rem;
}

.left-icon {
  margin-right: 0.5rem;
  width: 1.25rem;
  text-align: center;
}

.right-icon {
  margin-left: 0.5rem;
}

.badge {
  font-size: 0.75rem;
  font-weight: 600;
  border-radius: 12px;
  padding: 2px 8px;
  line-height: 1.2;
}
</style>
